import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { getDiscountPrice } from "../../helpers/product";
import ProductImageGallery from "../../components/product/ProductImageGallery";
import ProductDescriptionInfo from "../../components/product/ProductDescriptionInfo";
import ProductImageGallerySideThumb from "../../components/product/ProductImageGallerySideThumb";
import ProductImageFixed from "../../components/product/ProductImageFixed";
import { Button } from "react-bootstrap";
import ShopProducts from "./ShopProducts";
import { useState, useEffect } from "react";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";
import { getGrupoBioequivalentes } from "../../helpers/validators";

const ProductImageDescription = ({ spaceTopClass, spaceBottomClass, galleryType, product }) => {
  const currency = useSelector((state) => state.currency);
  const { cartItems } = useSelector((state) => state.cart);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { compareItems } = useSelector((state) => state.compare);
  const wishlistItem = wishlistItems.find(item => item.id === product.id);
  const compareItem = compareItems.find(item => item.id === product.id);

  const discountedPrice = getDiscountPrice(product.price, product.discount);
  const finalProductPrice = +(product.price * currency.currencyRate).toFixed(2);
  const finalDiscountedPrice = +(
    discountedPrice * currency.currencyRate
  ).toFixed(2);

  const { productsFull } = useSelector((state) => state.product)

  const [layout, setLayout] = useState('grid five-column');
  const getLayout = (layout) => {
    setLayout(layout)
  }



  const [arrBioequivalente, setArrBioequivalente] = useState([]);

  function eliminarPrimerTexto(texto) {
    const primerEspacio = texto.indexOf(" ");
    if (primerEspacio !== -1) {
      return texto.slice(primerEspacio + 1);
    } else {
      return texto;
    }
  }


  useEffect(() => {

    const getBioequivalentes = () => {
      setBioequivalentesVisible(false)
      // console.log("revisando")
      // console.log(product.nombre_medicamento)
      // console.log(product.kinf2)
      const arr = getGrupoBioequivalentes(product.kinf2)
      // console.log("arr")

      // console.log(arr)

      //filtro por bioequivalente, principio activo y concentración
      // let arrBio = productsFull.filter(item =>
      //   //principio activo
      //   item.principio_activo.toLowerCase() === product.principio_activo.toLowerCase()
      //   //concentracion
      //   && item.concentracion.toLowerCase() === product.concentracion.toLowerCase()
      //   //bioequivalente si
      //   && item.bioequivalente === 'BE'
      //   //distinto al producto revisado
      //   && item.kinf2 !== product.kinf2
      //   //contenido similar.
      //   //&& item.contenido.toLowerCase().includes(ultimoTextoProducto.toLowerCase())
      // )


      //casos particulares
      //console.log(product.nombre_medicamento)
      // if (
      //   product.nombre_medicamento.includes("SEROQUEL") ||
      //   product.nombre_medicamento.includes("RITALIN") ||
      //   product.nombre_medicamento.includes("ARADIX RETARD") ||
      //   product.nombre_medicamento.includes("RUBIFEN") || 
      //   product.nombre_medicamento.includes("NEBAPUL") 

      // ) {
      //   console.log("medicamentos especificos")
      //   //caso seroquel
      //   if (product.nombre_medicamento.includes("SEROQUEL")) {
      //     if (product.nombre_medicamento.includes("SEROQUEL XR")) {
      //       //caso seroquel xr, mostrar, sólo xr
      //       arrBio = arrBio.filter(item => item.nombre_medicamento.includes("XR"))
      //     }

      //     if (product.nombre_medicamento.includes("SEROQUEL") && !product.nombre_medicamento.includes("XR")) {
      //       //caso seroquel SOLO, NO MOSTRAR XR
      //       arrBio = arrBio.filter(item => !item.nombre_medicamento.includes("XR"))
      //     }
      //   }

      //   //caso ritalin
      //   if (product.nombre_medicamento.includes("RITALIN")) {
      //     console.log("caso ritalin")
      //     if (product.nombre_medicamento.includes("L.A.")) {
      //       //caso ritalin l.a. no mostrar bioequivalentes
      //       arrBio = []
      //     }

      //     if(!product.nombre_medicamento.includes("L.A.")){
      //       //caso ritalin solo, quitar retard
      //       arrBio =arrBio.filter(item=> !item.nombre_medicamento.includes("RETARD"))
      //     }

      //   }

      //   //caso aradix retard
      //   if(product.nombre_medicamento.includes("ARADIX RETARD")){
      //     //caso aradix retard, no mostrar bioequivalentes
      //     arrBio = []
      //   }

      //   if(product.nombre_medicamento.includes("RUBIFEN")){
      //     arrBio =arrBio.filter(item=> !item.nombre_medicamento.includes("RETARD"))

      //   }

      //   if(product.nombre_medicamento.includes("NEBAPUL")){
      //     arrBio =arrBio.filter(item=> !item.nombre_medicamento.includes("RETARD"))

      //   }






      // }





      // arrBio = arrBio.sort(compararPrecios)
      setArrBioequivalente(arr)




    }
    getBioequivalentes()
    return;
  }, [product]);
  const [bioequivalentesVisible, setBioequivalentesVisible] = useState(false);

  return (
    <div className={clsx("shop-area", spaceTopClass, spaceBottomClass)}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            {/* product image gallery */}
            {galleryType === "leftThumb" ? (
              <ProductImageGallerySideThumb
                product={product}
                thumbPosition="left"
              />
            ) : galleryType === "rightThumb" ? (
              <ProductImageGallerySideThumb product={product} />
            ) : galleryType === "fixedImage" ? (
              <ProductImageFixed product={product} />
            ) : (
              <ProductImageGallery product={product} />
            )}

            {/* <ProductImageGallery
              product={product}
            /> */}
          </div>
          <div className="col-lg-6 col-md-6">
            {/* product description info */}
            <ProductDescriptionInfo
              product={product}
              discountedPrice={discountedPrice}
              currency={currency}
              finalDiscountedPrice={finalDiscountedPrice}
              finalProductPrice={finalProductPrice}
              cartItems={cartItems}
              wishlistItem={wishlistItem}
              compareItem={compareItem}
            />
            <div
              className="text-center pt-20"
            >

              {
                (product.bioequivalente === 'BE' || product.bioequivalente === 'REF') &&
                  arrBioequivalente.length > 0
                  ?
                  <Button
                    //  onClick={() => handleBioequivalente()} 

                    style={{
                      borderRadius: "20px",
                      backgroundColor: "yellow",
                      color: "red",
                      border: "none",
                      fontSize: "1rem",
                      cursor: "pointer",
                      fontWeight: "bold"
                    }}

                    onClick={() => setBioequivalentesVisible(!bioequivalentesVisible)}
                  >
                    {!bioequivalentesVisible ? "Ver bioequivalentes" : "Ocultar bioequivalentes"}
                  </Button>

                  : null
              }
            </div>

          </div>

        </div>

        <div className="pt-30">

          {/* shop page content default */}
          {/* <ShopProducts layout={layout} products={products} /> */}
          {bioequivalentesVisible ?
            <div>
              <p className="fs-5 text-capitalize">{arrBioequivalente.length > 0 ? "Mostrando alternativas bioequivalentes de " : "Actualmente no contamos con alternativas bioequivalentes de "}<strong className="text-capitalize">{product.nombre_medicamento + " (" + product.contenido + ")"}</strong></p>
              <div className="d-flex row">
                {
                  arrBioequivalente.map(product => (
                    <div className="col-xl-3 col-sm-6" key={product.kinf2}>
                      <ProductGridListSingle
                        spaceBottomClass={'pb-20'}
                        product={product}
                        currency={currency}
                        cartItem={
                          cartItems.find(cartItem => cartItem.id === product.kinf2)
                        }
                        wishlistItem={
                          wishlistItems.find(
                            wishlistItem => wishlistItem.id === product.kinf2
                          )
                        }
                        compareItem={
                          compareItems.find(
                            compareItem => compareItem.id === product.kinf2
                          )
                        }
                      />
                    </div>
                  ))
                }
              </div>
            </div>


            :

            null
          }

        </div>

      </div>
    </div>
  );
};

ProductImageDescription.propTypes = {
  galleryType: PropTypes.string,
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default ProductImageDescription;
